/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isMobileWeb, getIconPath } from '@tcp/core/src/utils';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import Image from '@tcp/core/src/components/common/atoms/Image';
import {
  CheckMarkIcon,
  ErrorContainer,
  ErrorMessage,
  InfoIconCircle,
  StickyBanner,
  TextContainer,
} from '../styles/GlobalErrorComponent.style';

const GlobalErrorComponent = ({
  hideErrorAction,
  isVisible,
  errorMessage,
  fromModal,
  fromCartAndCheckoutPageError,
  errorMsg,
  clearCheckoutServerError,
  isMiniError,
  clearCartItemsSflError,
  errorMessageDuration,
  isGlobalHeaderRedesignEnabled,
  clearCheckoutClientError,
  clearAddToBagError,
  clearPickUpError,
  resetAddCardError,
  fromAtbError,
  hideClose,
  setMaxItemErrorAction,
  setOOSErrorAction,
  setBackPackDeletedErrorAction,
}) => {
  const [topValue, setTopValue] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const fadeDuration = 500;

  const resetState = () => {
    setFadeOut(false);
    if (fromCartAndCheckoutPageError) {
      clearCheckoutServerError({});
      clearCartItemsSflError(null);
      clearCheckoutClientError({});
      clearAddToBagError();
      clearPickUpError();
      setMaxItemErrorAction(false);
      setOOSErrorAction(false);
      setBackPackDeletedErrorAction(false);
    } else {
      resetAddCardError();
    }
    hideErrorAction();
  };

  const handleCloseClick = () => {
    setFadeOut(true);
    setTimeout(() => {
      if (fromCartAndCheckoutPageError) {
        clearCheckoutServerError({});
        clearCartItemsSflError(null);
        clearCheckoutClientError({});
        clearAddToBagError();
        clearPickUpError();
        setMaxItemErrorAction(false);
        setOOSErrorAction(false);
        setBackPackDeletedErrorAction(false);
      }
      setFadeOut(false);
      hideErrorAction();
    }, fadeDuration);
  };
  const { extraConfig } = React.useContext(LabelsContext) || {};
  const { isHeaderStickyClassPresent, stickyHeaderHeight } = extraConfig || {};
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    if (!isMobileWeb()) return;
    if (scrollTop > stickyHeaderHeight) {
      setTopValue(true);
    } else if (isHeaderStickyClassPresent && scrollTop < stickyHeaderHeight) {
      setTopValue(false);
    } else if (scrollTop < 170 && !isHeaderStickyClassPresent) {
      setTopValue(false);
    }
  };

  useEffect(() => {
    window?.addEventListener('scroll', handleScroll);
    return () => {
      window?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (fromAtbError) return undefined;
    setFadeOut(false);

    const fadeTimeout = setTimeout(() => {
      setFadeOut(true);
    }, errorMessageDuration - fadeDuration);

    const hideTimeout = setTimeout(() => {
      resetState();
    }, errorMessageDuration);

    return () => {
      clearTimeout(fadeTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isVisible, errorMessageDuration]);

  const { type, message } = errorMessage || {};
  const customPointerStyle = { cursor: 'pointer' };
  const isMobWebOrMiniBag = isMobileWeb() || isMiniError;
  const scrollTop = window?.scrollY;
  if (
    !fromCartAndCheckoutPageError &&
    scrollTop > 170 &&
    !isHeaderStickyClassPresent &&
    !topValue &&
    isMobileWeb()
  ) {
    setTopValue(true);
  }
  return (
    <StickyBanner
      fromModal={fromModal}
      isGlobalHeaderRedesignEnabled={isGlobalHeaderRedesignEnabled}
      fadeOut={fadeOut}
      stickyHeaderHeight={stickyHeaderHeight}
      topVal={topValue}
      isHeaderStickyClassPresent={isHeaderStickyClassPresent}
      fromAtbError={fromAtbError}
      fromCartAndCheckoutPageError={fromCartAndCheckoutPageError}
    >
      <ErrorContainer
        type={type}
        fromCartAndCheckoutPageError={fromCartAndCheckoutPageError}
        isMiniError={isMiniError}
      >
        <ErrorMessage isMiniError={isMiniError}>
          {type === 'error' || fromCartAndCheckoutPageError ? (
            <InfoIconCircle
              isMiniError={isMiniError}
              fromCartAndCheckoutPageError={fromCartAndCheckoutPageError}
              fromAtbError={fromAtbError}
            >
              !
            </InfoIconCircle>
          ) : (
            <CheckMarkIcon isMiniError={isMiniError} />
          )}
          <TextContainer
            component="span"
            fontSize={isMobWebOrMiniBag ? 'fs12' : 'fs14'}
            fontWeight="semibold"
            fontFamily="secondary"
            className={isMobWebOrMiniBag ? 'elem-ml-XS_1' : 'elem-ml-SM'}
            color="white"
          >
            {fromCartAndCheckoutPageError ? errorMsg : message}
          </TextContainer>
        </ErrorMessage>
        {!hideClose && (
          <Image
            className="close-button"
            src={getIconPath('white-close-icon')}
            alt="close-overlay"
            height={isMobWebOrMiniBag ? 16 : 18}
            width={isMobWebOrMiniBag ? 16 : 18}
            onClick={handleCloseClick}
            style={customPointerStyle}
          />
        )}
      </ErrorContainer>
    </StickyBanner>
  );
};

GlobalErrorComponent.propTypes = {
  hideErrorAction: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  errorMessage: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
  }),
  fromModal: PropTypes.bool,
  isErrorModalVisibleState: PropTypes.bool,
  fromCartAndCheckoutPageError: PropTypes.bool,
  errorMsg: PropTypes.string,
};

GlobalErrorComponent.defaultProps = {
  errorMessage: null,
  fromModal: false,
  isErrorModalVisibleState: false,
  fromCartAndCheckoutPageError: false,
  errorMsg: '',
};

export default GlobalErrorComponent;
export { GlobalErrorComponent as GlobalErrorComponentVanilla };
